import {
  APIKeysApi,
  BackOfficeApiKeyCreateResponse,
  BackOfficeApiKeyRecord,
  BackOfficeApiKeyScopeUsageRecord,
  ServiceName,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getApi = () => BackOfficeDataServiceAPI.getBackOfficeApi(APIKeysApi)
const getConfig = () => BackOfficeDataServiceAPI.getBackOfficeConfig()

const listAll = async (): Promise<BackOfficeApiKeyRecord[]> => {
  return await getApi().listAllApiKeys({ customerId: getConfig().customerId })
}

const getAvailableScopes = async (service: ServiceName): Promise<string[]> => {
  return await getApi().getServiceScopes({ customerId: getConfig().customerId, service })
}

const createKey = async (
  description: string,
  scopes: string[],
  service: ServiceName,
): Promise<BackOfficeApiKeyCreateResponse> => {
  return await getApi().createBackOfficeApiKey({
    customerId: getConfig().customerId,
    backOfficeApiKeyCreateRequest: { description, scopes, service },
  })
}

const updateKey = async (
  keyId: string,
  updates: { description?: string; scopes?: string[]; isActive?: boolean; service: ServiceName },
): Promise<BackOfficeApiKeyRecord> => {
  return await getApi().updateBackOfficeApiKey({
    customerId: getConfig().customerId,
    keyId,
    backOfficeApiKeyUpdateRequest: updates,
  })
}

const deleteKey = async (keyId: string, service: ServiceName): Promise<void> => {
  await getApi().deleteBackOfficeApiKey({ customerId: getConfig().customerId, keyId, service })
}

const rotateKey = async (
  keyId: string,
  service: ServiceName,
): Promise<BackOfficeApiKeyCreateResponse> => {
  return await getApi().rotateBackOfficeApiKey({
    customerId: getConfig().customerId,
    keyId,
    backOfficeApiKeyRotateRequest: { service },
  })
}

const lookupKey = async (encodedKey: string): Promise<BackOfficeApiKeyRecord> => {
  return await getApi().lookupBackOfficeApiKey({
    customerId: getConfig().customerId,
    backOfficeApiKeyLookupRequest: { encodedKey },
  })
}

const getScopeUsage = async (
  keyId: string,
  service: ServiceName,
): Promise<BackOfficeApiKeyScopeUsageRecord[]> => {
  return await getApi().getApiKeyScopeUsage({ customerId: getConfig().customerId, keyId, service })
}

export const ApiKeysServiceAPI = {
  listAll,
  getAvailableScopes,
  createKey,
  updateKey,
  deleteKey,
  rotateKey,
  lookupKey,
  getScopeUsage,
}
